import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Navbar, Footer, Breadcrumbs } from "../../components/shared";
import { useCheckAccess } from "../../utils/Utilities";
import { sendBulkSms } from "../../service/ContactApi";

function BulkSmsSend() {
  useCheckAccess("ContactAdmin");

  const [loading, setLoading] = useState(false);
  const [batchResults, setBatchResults] = useState([]);
  const [error, setError] = useState(null);
  const [collection, setCollection] = useState("test_family_members");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [message, setMessage] = useState('');

  const handleConfirmSend = async () => {
    setShowConfirmModal(false);
    await proceedWithSmsSend();
  };

  const startBulkSmsSend = async () => {
    if (collection === "family_members") {
      setShowConfirmModal(true);
    } else {
      await proceedWithSmsSend();
    }
  };

  const proceedWithSmsSend = async () => {
    setLoading(true);
    setBatchResults([]);
    setError(null);

    try {
      const response = await sendBulkSms(JSON.stringify({ collection, message }));

      if (!response.ok) {
        throw new Error("Failed to trigger bulk SMS sending");
      }

      const data = await response.json();

      setBatchResults([
        {
          batch: "All",
          successCount: "-",
          failedCount: "-",
          message: data.message,
        },
      ]);
    } catch (err) {
      setError(err.message || "Unknown error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <Helmet>
        <title>Bulk SMS Send</title>
        <link rel="canonical" href="/sms/bulk-send" />
      </Helmet>

      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            <Breadcrumbs />
            <br />
            <h3>பெருமளவு SMS அனுப்புதல்</h3>
            <br />

            {/* Select collection */}
            <div className="detail-item">
              <label htmlFor="collection">அகராதி தொகுப்பு (Collection): </label>
              <select
                id="collection"
                value={collection}
                onChange={(e) => setCollection(e.target.value)}
                className="auth_input"
              >
                <option value="">-- Collection ஒன்றை தேர்ந்தெடுக்கவும் --</option>
                <option value="test_family_members">test_family_members</option>
                <option value="family_members">family_members</option>
              </select>

              {collection === "family_members" && (
                <div style={{ color: "red", marginTop: "10px", fontWeight: "bold" }}>
                  ⚠️ நீங்கள் இப்போது உண்மையான பயனர்களுக்கு SMS அனுப்ப இருக்கிறீர்கள்.
                </div>
              )}
            </div>
            <div className="detail-item">
              <label htmlFor="smsMessage">தேர்ந்தெடுக்கவும் SMS செய்தி:</label>
              <select
                id="smsMessage"
                className="auth_input"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              >
                <option value="">-- SMS ஒன்றை தேர்ந்தெடுக்கவும் --</option>
                <option value="நாளை மாலை 6மணிக்கு பௌர்ணமி பூசை நடைபெறும்–ஸ்ரீ பொன்னாச்சியம்மன் PONACH">
                  நாளை மாலை 6மணிக்கு பௌர்ணமி பூசை நடைபெறும்–ஸ்ரீ பொன்னாச்சியம்மன் PONACH
                </option>
                <option value="நாளை மதியம் அமாவாசை பூசைக்கு வாருங்கள்–ஸ்ரீபொன்னாச்சியம்மன் PONACH">
                  நாளை மதியம் அமாவாசை பூசைக்கு வாருங்கள்–ஸ்ரீபொன்னாச்சியம்மன் PONACH
                </option>
              </select>
            </div>


            <button
              type="button"
              className="auth_submit"
              disabled={loading}
              onClick={startBulkSmsSend}
            >
              {loading ? "அனுப்புகிறது..." : "SMS அனுப்ப தொடங்கு"}
            </button>

            <br />
            <br />

            {error && <div className="auth_error">❗ {error}</div>}

            {/* Show batch results */}
            {batchResults.length > 0 && (
              <div>
                <h4>பதில்கள்:</h4>
                <table className="detail-table" style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr>
                      <th>பேச்சு எண்</th>
                      <th>வெற்றி</th>
                      <th>தோல்வி</th>
                      <th>செய்தி</th>
                    </tr>
                  </thead>
                  <tbody>
                    {batchResults.map((batch, idx) => (
                      <tr key={idx}>
                        <td>{batch.batch}</td>
                        <td>{batch.successCount}</td>
                        <td>{batch.failedCount}</td>
                        <td>{batch.message || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />

      {/* Confirmation Modal */}
      {showConfirmModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: "100vw",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "20px",
              borderRadius: "8px",
              width: "90%",
              maxWidth: "400px",
              textAlign: "center",
            }}
          >
            <h3>உறுதிப்படுத்தல் தேவை</h3>
            <p>
              இது <strong>உண்மையான பயனர்கள்</strong> ஆகும்.<br />
              SMS அனுப்ப தொடர விரும்புகிறீர்களா?
            </p>
            <div style={{ marginTop: "20px" }}>
              <button
                onClick={handleConfirmSend}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#007bff",
                  color: "#fff",
                  border: "none",
                  marginRight: "10px",
                  cursor: "pointer",
                  borderRadius: "5px",
                }}
              >
                ஆம், அனுப்பு
              </button>
              <button
                onClick={() => setShowConfirmModal(false)}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#ccc",
                  border: "none",
                  cursor: "pointer",
                  borderRadius: "5px",
                }}
              >
                இல்லை, ரத்து செய்
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default BulkSmsSend;
